<template>
  <div class="content_box">
    <div class="logManage" id="ManageTable">
      <div class="userManage_header">
        <div class="userManage_logo">
          <img src="@/assets/imgs/icon/reportSetup_logo.png" alt />
        </div>
        <h3>报表设置</h3>
      </div>
      <el-form :inline="true" :model="searchObj" class="demo-form-inline">
        <el-form-item label="填报周期">
          <el-select v-model="searchObj.reportCycle" placeholder="请选择">
            <el-option label="月报" value="0"></el-option>
            <el-option label="季报" value="1"></el-option>
            <el-option label="半年报" value="2"></el-option>
            <el-option label="年报" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报表名称">
          <el-input
            v-model.trim="searchObj.reportName"
            placeholder="请输入报表名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="报表状态">
          <el-select v-model="searchObj.reportStatus" placeholder="请选择">
            <el-option label="启用" value="0"></el-option>
            <el-option label="禁用" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="onSubmit"
            class="bg5584FF formBotton"
            >查询</el-button
          >
          <el-button type="info" @click="reset" class="formBotton"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
      <hr class="hr" />
      <el-table
        :data="tableData"
        stripe
        style="width: 100%"
        :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
        v-loading="loading"
      >
        <el-table-column
          align="center"
          type="index"
          width="100"
          label="序号"
        ></el-table-column>
        <el-table-column prop="reportName" label="报表名称"></el-table-column>
        <el-table-column
          prop="reportType"
          label="报表类型"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="reportCode"
          label="报表编号"
          width="80"
          align="center"
        ></el-table-column>
        <el-table-column prop="reportStatus" label="报表状态" align="center">
          <template slot-scope="scope">{{
            scope.row.reportStatus == 0 ? "启用" : "停用"
          }}</template>
        </el-table-column>
        <el-table-column prop="reportCycle" label="填报周期" align="center">
          <template slot-scope="scope">{{
            scope.row.reportCycle == 0
              ? "月报"
              : scope.row.reportCycle == 1
              ? "季报"
              : scope.row.reportCycle == 2
              ? "半年报"
              : "年报"
          }}</template>
        </el-table-column>
        <el-table-column
          prop="reportTime"
          label="填报开始时间"
          align="center"
        ></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              class="bg5584FF"
              @click="handleEdit(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="primary"
              size="mini"
              class="bg5584FF"
              @click="handleCreate(scope.row)"
              >生成报表</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pageBox">
        <!-- <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page.sync="currentPage"
          :page-size="10"
          layout="prev, pager, next, jumper"
          :total="total"
        ></el-pagination> -->
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          layout="total,  prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
      <el-dialog
        title="编辑"
        :visible.sync="editDialogVisible"
        class="dialog1131 titleChange"
        :close-on-click-modal="false"
        @closed="addHandleClose"
      >
        <el-form
          :inline="true"
          :model="editObj"
          class="demo-form-inline half radioMarginTop7 marginBottom30"
          size="mini"
          label-width="124px"
          label-position="left"
          ref="addForm"
          :rules="rules"
          v-loading="editLoading"
        >
          <el-form-item label="报表类型" style="width: 45%">
            <el-input
              v-model.trim="editObj.reportType"
              placeholder
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="报表周期" style="width: 45%">
            <el-radio-group v-model="editObj.reportCycle">
              <el-radio :label="0">月报</el-radio>
              <el-radio :label="1">季报</el-radio>
              <el-radio :label="2">半年报</el-radio>
              <el-radio :label="3">年报</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="报表名称" style="width: 45%">
            <el-input
              v-model.trim="editObj.reportName"
              placeholder
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="填报开始时间" style="width: 45%">
            <el-date-picker
              v-model="editObj.reportTime"
              type="month"
              placeholder="选择日期"
              format="yyyy-MM"
              value-format="yyyy-MM"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="报表编号" style="width: 45%">
            <el-input
              v-model.trim="editObj.reportCode"
              placeholder
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item
            label="填报有效期"
            style="width: 45%"
            prop="reportEffective"
          >
            <span>开始填报后</span>
            <el-input
              v-model.trim="editObj.reportEffective"
              placeholder="请输入1~12的数字"
              style="width: 130px; margin-right: 5px"
            ></el-input>
            <span>个月内有效</span>
          </el-form-item>
          <el-form-item label="报表状态">
            <el-radio-group v-model="editObj.reportStatus">
              <el-radio :label="0">启用</el-radio>
              <el-radio :label="1">停用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="催报设置"
            style="width: 45%"
            prop="reportReminderDay"
          >
            <span>当期报表开始后</span>
            <el-input
              v-model.trim="editObj.reportReminderDay"
              placeholder="请输入1~99的数字"
              style="width: 130px"
            ></el-input>
            <span>天进行催报</span>
          </el-form-item>
          <el-form-item label="数据采集对象" style="width: 45%">
            <el-button
              type="primary"
              size="mini"
              class="bg5584FF"
              @click="addData"
              >添加</el-button
            >
          </el-form-item>
          <el-form-item label="异动指标提醒设置" style="width: 45%">
            <el-radio-group v-model="editObj.reportYidong">
              <el-radio :label="0">启用</el-radio>
              <el-radio :label="1">禁止</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="审核部门" style="width: 45%">
            <el-cascader
              v-model="editObj.reportReviews"
              :options="options"
              :props="deftProps"
              collapse-tags
              clearable
            ></el-cascader>
          </el-form-item>
          <el-form-item style="width: 100%">
            <div style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"></div>
          </el-form-item>
          <el-form-item style="width: 100%">
            <div class="btnBox">
              <el-button
                type="primary"
                size="mini"
                class="bg5584FF"
                @click="sureAdd('addForm')"
                >确定</el-button
              >
              <el-button
                type="normal"
                size="mini"
                @click="editDialogVisible = false"
                >取消</el-button
              >
            </div>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 数据采集对象 -->
      <el-dialog
        title="采集对象选择"
        :visible.sync="detailDialogVisible"
        class="dialog550"
        :close-on-click-modal="false"
        @closed="handleClose"
      >
        <div class="acquisition">
          <div class="acquisition_tree">
            <el-tree
              :props="props"
              :data="treeData"
              show-checkbox
              @check-change="handleCheckChange"
              node-key="id"
              :default-checked-keys="defCheckedArr"
              :default-expanded-keys="defCheckedArr"
              ref="acquisitionTree"
            ></el-tree>
          </div>
          <div class="acquisition_content">
            <div class="tags" v-for="item in tagsArr" :key="item.id">
              <span class="tag-text">{{ item.name }}</span>
              <span
                class="close-btn"
                @click="deleteOneTag($event)"
                :data-code="item.id"
                >×</span
              >
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { Message } from "element-ui";
export default {
  data() {
    var reminderDay = (rule, value, callback) => {
      if (!value) {
        callback();
      } else {
        setTimeout(() => {
          if (!Number.isInteger(+value)) {
            callback(new Error("请输入数字值"));
          } else {
            this.$axios
              .get(
                `/system/reportSetting/verification?reportEffective=${this.editObj.reportEffective}&reportReminderDay=${value}&reportTime=${this.editObj.reportTime}`
              )
              .then((res) => {
                if (res.data) {
                  callback();
                } else {
                  callback(new Error("催报天数不能超过报表有效期"));
                }
              });
            // if (value < 1 || value > 99) {
            //   callback(new Error("请输入1~99的数字"));
            // } else {
            //   callback();
            // }
          }
        }, 100);
      }
    };
    var effective = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("填报有效期不能为空！"));
      } else {
        setTimeout(() => {
          if (!Number.isInteger(+value)) {
            callback(new Error("请输入数字值"));
          } else {
            if (value < 1 || value > 12) {
              callback(new Error("请输入1~12的数字"));
            } else {
              callback();
            }
          }
        }, 100);
      }
    };
    return {
      editDialogVisible: false, //编辑
      detailDialogVisible: false,
      editLoading: false,
      currentPage: 1,
      pageNum: 1,
      total: 0,
      rowId: "",
      examine: "",
      modifyContent: "",
      reportReviewType: "",
      loading: false,
      searchObj: {
        reportCycle: "",
        reportName: "",
        reportStatus: "",
      },
      tableData: [],
      fileList: [],
      defCheckedArr: [],
      checkedTreeData: [],
      tagsArr: [],
      ReportReviewNames: [],
      editObj: {
        reportReviews: "",
        reportCompany: "",
      },
      rules: {
        reportReminderDay: [
          { required: false, validator: reminderDay, trigger: "blur" },
        ],
        reportEffective: [
          { required: true, validator: effective, trigger: "blur" },
        ],
      },
      options: [],
      treeData: [],
      props: {
        children: "children",
        label: "name",
      },
      deftProps: {
        multiple: true,
        label: "name",
        value: "name",
      },
    };
  },
  created() {
    this.getData({ pageNum: 1, pageSize: 10 });
    this.getSelectList();
  },
  methods: {
    handleCreate(row) {
      console.log(row.reportCode);
      if (row.reportCode == "001") {
        console.log(row.reportName);
        this.$axios
          .get("/business/report/czbScheduling")
          .then((res) => {
            console.log(res);
          })
          .catch((error) => {
            console.error(error);
          });
      } else if (row.reportCode == "002") {
        this.$axios
          .get("/business/report/cwbScheduling")
          .then((res) => {
            console.log(res);
          })
          .catch((error) => {
            console.error(error);
          });
      } else if (row.reportCode == "003") {
        this.$axios
          .get("/business/report/qkbScheduling")
          .then((res) => {
            console.log(res);
          })
          .catch((error) => {
            console.error(error);
          });
      }
      // this.$axios
      //   .get("/system/reportSetting/searchPageList", { params: pms })
      //   .then((res) => {
      //     this.loading = false;
      //     this.tableData = res.data;
      //     this.total = res.total;
      //   })
      //   .catch((error) => {
      //     this.loading = false;
      //     // console.log(error);
      //   });
    },
    getData(pageObj, searchObj) {
      this.loading = true;
      let pms = Object.assign(pageObj, searchObj);
      this.$axios
        .get("/system/reportSetting/searchPageList", { params: pms })
        .then((res) => {
          this.loading = false;
          this.tableData = res.data;
          this.total = res.total;
        })
        .catch((error) => {
          this.loading = false;
          // console.log(error);
        });
    },
    getSelectList() {
      //获取审核部门列表
      this.$axios
        .get("/system/reportSetting/selectDepartmentTree")
        .then((res) => {
          this.options = res.data;
        });
    },
    onSubmit() {
      //查询
      this.getData({ pageNum: 1, pageSize: 10 }, this.searchObj);
    },
    reset() {
      //重置
      // console.log("onReset");
      for (const key in this.searchObj) {
        this.searchObj[key] = "";
      }
      this.getData({ pageNum: 1, pageSize: 10 });
    },
    sureAdd(formName) {
      //编辑表单提交
      // console.log(this.editObj);

      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editLoading = true;
          this.$axios
            .post("/system/reportSetting/updateReportSetting", this.editObj)
            .then((res) => {
              Message.success("编辑成功");
              this.editLoading = false;
              this.editDialogVisible = false;
              this.getData({ pageNum: 1, pageSize: 10 }, this.searchObj);
            })
            .catch(() => {
              this.editLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleEdit(row) {
      this.rowId = row.id;
      this.editDialogVisible = true;
      this.$axios
        .get(`/system/reportSetting/selectByPrimaryKey/${row.id}`)
        .then((res) => {
          this.editObj = res.data;
          this.defCheckedArr = JSON.parse(res.data.reportCompany);
        });
      this.$axios
        .get(`/system/reportSetting/selectUnit/${this.rowId}`)
        .then((res) => {
          this.tagsArr = res.data;
          if (res.data.length > 10) {
            this.checkedTreeData = res.data.slice(0, 10);
            this.checkedTreeData.push({ name: "..." });
          } else {
            this.checkedTreeData = res.data;
          }
        });
    },
    handleDelete() {},
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      //跳转页
      // console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getData({ pageNum: val, pageSize: 10 }, this.searchObj);
    },
    addHandleClose() {
      this.$refs.addForm.resetFields();
      this.reportReviewType = "";
      this.ReportReviewNames = [];
    },
    addData() {
      this.detailDialogVisible = true;
      this.$axios
        .get(`/system/reportSetting/selectTree/${this.rowId}`)
        .then((res) => {
          this.treeData = res.data;
        });

      this.checkedTreeData = [];
    },
    handleCheckChange(data) {
      // console.log(data);
      let currCheckedArr = this.$refs.acquisitionTree.getCheckedNodes(true); // 得到所有被勾选的子级节点
      // console.log(currCheckedArr);
      this.tagsArr = currCheckedArr;
    },
    deleteOneTag(e) {
      // console.log(e.target.dataset.code);
      let currCheckedArr = this.$refs.acquisitionTree.getCheckedNodes(true); // 得到所有被勾选的子级节点
      let midHyArr = [];
      currCheckedArr.forEach((item, index) => {
        if (item.id != e.target.dataset.code) {
          midHyArr.push({ code: item.id, name: item.title });
        } else {
          this.$refs.acquisitionTree.setChecked(item.id, false);
        }
      });
    },
    handleClose() {
      let currCheckedArr = this.$refs.acquisitionTree.getCheckedNodes(true);
      let midHyArr = [];
      currCheckedArr.forEach((item) => {
        midHyArr.push(item.id);
      });

      this.editObj.reportCompany = JSON.stringify(midHyArr);
      // this.editObj.reportCompany = midHyArr;
      // console.log(this.editObj.reportCompany);
      if (currCheckedArr.length > 10) {
        this.checkedTreeData = currCheckedArr.slice(0, 10);
        this.checkedTreeData.push({ name: "..." });
      } else {
        this.checkedTreeData = currCheckedArr;
      }
      // console.log(this.checkedTreeData);
      this.treeData = [];
      this.$axios
        .get(`/system/reportSetting/selectUnit/${this.rowId}`)
        .then((res) => {
          this.tagsArr = res.data;
          if (res.data.length > 10) {
            this.checkedTreeData = res.data.slice(0, 10);
            this.checkedTreeData.push({ name: "..." });
          } else {
            this.checkedTreeData = res.data;
          }
        });
    },
  },
};
</script>
 <style lang="less" scoped>
.content_box {
  padding: 20px 30px 30px;
}
@media (max-width: 1200px) {
  .content_box {
    padding: 20px 10px 30px;
  }
}
.logManage {
  box-shadow: 0px 0px 50px #ccc;
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  .userManage_header {
    height: 31px;
    width: 100%;
    display: flex;
    margin-bottom: 30px;
    .userManage_logo {
      margin: 2px 20px 0 2px;
    }
    h3 {
      font-size: 24px;
      height: 100%;
      margin: 0;
      color: #444444;
    }
  }
  .userManage_form {
    height: 70px;
    width: 100%;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(155, 155, 155, 0.25);
    margin-bottom: 20px;
    .el-form {
      .el-form-item {
        margin-right: 29px;
      }
    }
  }
}
.addUser {
  width: 100%;
  height: 100%;
}
.acquisition {
  width: 100%;
  height: 100%;
  display: flex;
  border: 1px solid rgba(155, 155, 155, 0.25);
  .acquisition_tree {
    min-width: 25%;
    height: 100%;
    overflow: auto;
    border-right: 1px solid rgba(155, 155, 155, 0.25);
  }
  .acquisition_content {
    flex: 1;
    overflow: auto;
  }
}
.dataContent {
  box-sizing: border-box;
  padding-left: 12px;
}
.tags {
  margin: 3px 5px;
  display: inline-block;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: #f5f9fb;
  border-radius: 4px;
  padding: 0 5px;
  .tag-text {
    margin-right: 5px;
    font-size: 12px;
  }
  .close-btn {
    width: 10px;
    height: 10px;
    color: #64a4c9;
    cursor: pointer;
  }
}
.dataDepartment {
  width: 100%;
  margin-bottom: 30px;
  box-sizing: border-box;
  padding-left: 123px;
}
</style>